export default __webpack_public_path__ + "static/media/metro-profile.c9c6d162.svg";